<!--
  @author:chen.hao
  @time:2018/10/13
  @disc:广告位编辑/新增弹出层
 -->

<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="600px"
    @close="handleClose">
    <el-form ref="form" :model="form" label-width="110px" :rules="rules">
      <el-form-item label="终端类型" prop="deviceType">
        <el-radio-group v-model="form.deviceType" @change="onTypeChange">
          <el-row>
            <el-col
              v-for="item in deviceTypeArr"
              :span="12"
              :key="item.value">
              <el-radio :label="item.value">{{item.label}}</el-radio>
            </el-col>
          </el-row>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="广告位名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入广告位名称" maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="广告位标识符" prop="code">
        <el-select v-model="form.code" clearable :disabled="isEdit">
          <el-option v-for="item in codeOptions"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="广告位描述" prop="statement">
        <el-input
          v-model="form.statement"
          placeholder="请输入广告位描述"
          type="textarea"
          maxlength="50"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'addOrEditDialog',
  props: ['show', 'info'],
  data () {
    return {
      visible: this.show,
      deviceTypeArr: [
        { value: 1, label: '商城PC端' },
        { value: 2, label: '商城APP端' }
        // { value: 3, label: '司机预约微信端' },
        // { value: 4, label: '物流司机端' },
        // { value: 5, label: '散客司机端' }
      ],
      form: {},
      baseForm: {
        id: '',
        deviceType: '',
        name: '',
        code: '',
        statement: ''
      },
      rules: {
        deviceType: [{ required: true, message: '请选择终端类型' }],
        name: [{ required: true, message: '广告位名称不能为空' }],
        code: [{ required: true, message: '广告位标识符不能为空' }]
      }
    }
  },
  computed: {
    isEdit () {
      return !this.$lodash.isEmpty(this.info)
    },
    title () {
      return this.isEdit ? '编辑' : '新增'
    },
    codeOptions () {
      const map = {
        1: [
          '首页第一广告位（轮播）',
          '首页第二广告位',
          '首页第三广告位',
          '活动专栏广告位',
          '京博简介广告位',
          '下载中心广告位',
          '邀请记录广告位'
        ],
        2: [
          '首页第一广告位（轮播）',
          '首页第二广告位（轮播）'
        ]
      }
      return map[this.form.deviceType]
    }
  },
  methods: {
    ...mapActions(['getAdSpaceList', 'addAdSpace', 'editAdSpace']),
    onTypeChange () {
      this.form.code = ''
      this.$nextTick(() => {
        this.$refs.form.clearValidate('code')
      })
    },
    handleSubmit () {
      this.$refs.form.validate(val => {
        if (val) {
          let action = this.isEdit ? this.editAdSpace : this.addAdSpace
          action({ ...this.form }).then(() => {
            this.getAdSpaceList()
            this.visible = false
          })
        }
      })
    },
    handleClose () {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        if (this.isEdit) {
          this.form = { ...this.info }
        } else {
          this.form = { ...this.baseForm }
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input, .el-select {
  width: 200px;
}

.el-radio-group {
  line-height: 32px;
  .el-radio {
    vertical-align: middle;
  }
}
</style>
